class TruncatedTextElement extends HTMLElement {
  connectedCallback() {
    if (!this.contentNode) {
      this.contentNode = this.querySelector('[data-ref="truncated-text-text"]');
    }
    if (!this.triggerNode) {
      this.triggerNode = this.querySelector('[data-ref="truncated-text-trigger"]');
    }

    if (!this.contentNode || !this.triggerNode) {
      return;
    }

    if (!this.hasAttribute('data-expanded')) {
      this.setAttribute('data-expanded', 'false');
    }

    this.triggerNode.addEventListener('click', this.handleClickTrigger);
  }

  disconnectedCallback() {
    if (this.triggerNode) {
      this.triggerNode.removeEventListener('click', this.handleClickTrigger);
    }
    if (this.contentNode) {
      this.contentNode.removeEventListener('transitionend', this.handleTransEnd);
    }
  }

  handleClickTrigger = () => {
    const open = this.getAttribute('data-expanded') === 'true';
    if (open) {
      this.animateClose();
    } else {
      this.animateOpen();
    }
  };

  animateClose = () => {
    requestAnimationFrame(() => {
      const contentHeight = this.contentNode.scrollHeight;
      this.contentNode.style.height = `${contentHeight}px`;
      requestAnimationFrame(() => {
        this.contentNode.style.height = null;
      });
    });

    this.setAttribute('data-expanded', 'false');
  };

  animateOpen = () => {
    if (this.getAttribute('data-expanded') === 'false') {
      const contentHeight = this.contentNode.scrollHeight;
      this.contentNode.style.height = `${contentHeight}px`;

      this.setAttribute('data-expanded', 'true');

      this.contentNode.addEventListener('transitionend', this.handleTransEnd);
    }
  };

  handleTransEnd = () => {
    this.contentNode.style.height = 'auto';
    if (this.footnote) {
      this.footnote.scrollIntoView(true);
    }
    this.footnote = null;
    this.contentNode.removeEventListener('transitionend', this.handleTransEnd);
  };
}

if (!customElements.get('truncated-text')) {
  customElements.define('truncated-text', TruncatedTextElement);
}

export default TruncatedTextElement;
